import { useCallback } from "react";

const useGetCsrfToken = () => {
  const getCsrfTokenFromMeta = useCallback((): string | null => {
    const tokenTag =
      document && document.querySelector('meta[name="csrf-token"]');
    return tokenTag && tokenTag.getAttribute("content");
  }, []);

  return { getCsrfToken: getCsrfTokenFromMeta };
};

export { useGetCsrfToken };
